class IdealMobileNavigation extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.dialog = this.querySelector('dialog');
    this.scroller = this.querySelector('.imn-scroll');
    this.home = this.querySelector('[data-imn-home]');
    this.drill = this.querySelector('[data-imn-drill]');
    this.history = [];
    this.tabs = this.querySelector('.imn-tabs');
    this.selectedTab = this.querySelector('[data-imn-tab][aria-selected="true"]').dataset.imnTab;
    this.setupSlidingTabs();
    this.setupMenuSwipe();
    this.querySelectorAll('[data-imn-panel]').forEach(panel => { if (!['more','more-main'].includes(panel.dataset.imnPanel)) this.drill.appendChild(panel); });
    this.openHandler = event => {
      const toggle = event.target.closest('[data-menu-toggle]');
      if (!toggle || (!window.matchMedia('(max-width:1023px)').matches && !this.hasAttribute('data-imn-preview'))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.openMenuTimer || this.dialog.open) return;
      this.opener = toggle;
      this.history = [];
      this.reset();
      toggle.classList.add('imn-menu-pressed');
      this.openMenuTimer = setTimeout(() => {
        this.openMenuTimer = null;
        toggle.classList.remove('imn-menu-pressed');
        if (!this.isConnected || (!window.matchMedia('(max-width:1023px)').matches && !this.hasAttribute('data-imn-preview'))) return;
        this.dialog.showModal();
        this.querySelector('#imn-title').focus({preventScroll:true});
        document.documentElement.classList.add('imn-open');
        toggle.setAttribute('aria-expanded', 'true');
      }, event.detail ? 120 : 0);
    };
    this.clickHandler = event => {
      if (event.target.closest('[data-imn-close]')) { this.dialog.close(); return; }
      const tab = event.target.closest('[data-imn-tab]');
      if (tab) {
        if (event.detail && performance.now() < (this.suppressTabClickUntil || 0)) {
          this.suppressTabClickUntil = 0;
          event.preventDefault();
          return;
        }
        this.selectTab(tab.dataset.imnTab);
      }
      const open = event.target.closest('[data-imn-open]');
      if (open) this.showPanel(open.dataset.imnOpen, open);
      if (event.target.closest('[data-imn-back]')) this.goBack();
      if (event.target === this.dialog) {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right) this.dialog.close();
      }
    };
    this.closeHandler = () => {
      this.cancelMenuSwipe();
      document.documentElement.classList.remove('imn-open');
      if (this.opener) {
        this.opener.setAttribute('aria-expanded', 'false');
        this.opener.focus();
      }
    };
    this.keyHandler = event => {
      const tab = event.target.closest('[data-imn-tab]');
      if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const name = event.key === 'Home' ? 'categories' : event.key === 'End' ? 'brands' : tab.dataset.imnTab === 'categories' ? 'brands' : 'categories';
      this.selectTab(name);
      this.querySelector('[data-imn-tab="' + name + '"]').focus();
    };
    this.resizeHandler = () => { if (window.innerWidth > 1023 && !this.hasAttribute('data-imn-preview') && this.dialog.open) this.dialog.close(); };
    document.addEventListener('click', this.openHandler, true);
    this.dialog.addEventListener('click', this.clickHandler);
    this.dialog.addEventListener('close', this.closeHandler);
    this.dialog.addEventListener('keydown', this.keyHandler);
    window.addEventListener('resize', this.resizeHandler);
  }
  setupSlidingTabs() {
    this.tabPointerDown = event => {
      if (!event.isPrimary || event.button !== 0) return;
      this.tabGesture = {id:event.pointerId,x:event.clientX,y:event.clientY,start:this.selectedTab === 'brands' ? 1 : 0,progress:this.selectedTab === 'brands' ? 1 : 0,dragging:false};
    };
    this.tabPointerMove = event => {
      const gesture = this.tabGesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.dragging) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { this.tabGesture = null; return; }
        if (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy)) return;
        gesture.dragging = true;
        this.tabs.setPointerCapture(event.pointerId);
        this.tabs.classList.add('is-dragging');
      }
      event.preventDefault();
      const travel = Math.max(1,(this.tabs.getBoundingClientRect().width - 6)/2);
      gesture.progress = Math.max(0,Math.min(1,gesture.start + dx/travel));
      this.tabs.style.setProperty('--imn-position',gesture.progress);
    };
    this.tabPointerEnd = event => {
      if (event.type === 'lostpointercapture' && event.target !== this.tabs) return;
      const gesture = this.tabGesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      this.tabGesture = null;
      this.tabs.classList.remove('is-dragging');
      if (gesture.dragging) {
        const cancelled = event.type === 'pointercancel' || event.type === 'lostpointercapture';
        this.selectTab(cancelled ? this.selectedTab : gesture.progress >= .5 ? 'brands' : 'categories');
        this.suppressTabClickUntil = performance.now() + 350;
        if (this.tabs.hasPointerCapture(event.pointerId)) this.tabs.releasePointerCapture(event.pointerId);
      }
    };
    this.tabs.addEventListener('pointerdown',this.tabPointerDown);
    this.tabs.addEventListener('pointermove',this.tabPointerMove);
    ['pointerup','pointercancel','lostpointercapture'].forEach(type => this.tabs.addEventListener(type,this.tabPointerEnd));
  }
  setupMenuSwipe() {
    this.swipePointerDown = event => {
      if (!event.isPrimary || event.button !== 0 || !this.dialog.open || event.clientX <= 12) return;
      if (event.target === this.dialog) return;
      if (event.target.closest('input,textarea,select,[contenteditable="true"],.imn-tabs')) return;
      this.swipeGesture = {id:event.pointerId,x:event.clientX,y:event.clientY,dragging:false};
    };
    this.swipePointerMove = event => {
      const gesture = this.swipeGesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.dragging) {
        if (Math.abs(dy) > 8 && Math.abs(dy) >= Math.abs(dx)) { this.cancelMenuSwipe(); return; }
        if (Math.abs(dx) < 12 || Math.abs(dx) <= Math.abs(dy) * 1.5) return;
        gesture.dragging = true;
        this.dialog.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
    };
    this.swipePointerEnd = event => {
      if (event.type === 'lostpointercapture' && event.target !== this.dialog) return;
      const gesture = this.swipeGesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      const threshold = Math.max(60, Math.min(100, this.dialog.getBoundingClientRect().width * .22));
      const navigate = gesture.dragging && event.type === 'pointerup' && Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.5;
      if (gesture.dragging) this.suppressSwipeClickUntil = performance.now() + 400;
      this.cancelMenuSwipe();
      if (navigate) {
        if (dx > 0 && this.currentPanel && this.history.length) this.goBack();
        else this.dialog.close();
      }
    };
    this.swipeClickHandler = event => {
      if (event.detail && performance.now() < (this.suppressSwipeClickUntil || 0)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    this.dialog.addEventListener('pointerdown', this.swipePointerDown);
    this.dialog.addEventListener('pointermove', this.swipePointerMove);
    ['pointerup','pointercancel','lostpointercapture'].forEach(type => this.dialog.addEventListener(type, this.swipePointerEnd));
    this.dialog.addEventListener('click', this.swipeClickHandler, true);
  }
  cancelMenuSwipe() {
    const gesture = this.swipeGesture;
    this.swipeGesture = null;
    if (gesture && this.dialog.hasPointerCapture(gesture.id)) this.dialog.releasePointerCapture(gesture.id);
  }
  selectTab(name) {
    this.selectedTab = name;
    this.tabs.style.setProperty('--imn-position',name === 'brands' ? 1 : 0);
    this.querySelectorAll('[data-imn-tab]').forEach(tab => {
      const selected = tab.dataset.imnTab === name;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    this.querySelector('#imn-categories').hidden = name !== 'categories';
    this.querySelector('#imn-brands').hidden = name !== 'brands';
  }
  reset() {
    this.cancelMenuSwipe();
    this.currentPanel = null;
    this.home.hidden = false;
    this.drill.hidden = true;
    this.querySelectorAll('[data-imn-panel]').forEach(panel => { panel.hidden = !['categories','more-main'].includes(panel.dataset.imnPanel); });
  }
  showPanel(id, trigger) {
    this.cancelMenuSwipe();
    const panel = this.querySelector('[data-imn-panel="' + id + '"]');
    if (!panel) return;
    this.history.push({panel: this.currentPanel || null, scroll: this.scroller.scrollTop, trigger});
    this.querySelectorAll('[data-imn-panel]').forEach(p => { p.hidden = true; });
    this.home.hidden = true;
    this.drill.hidden = false;
    panel.hidden = false;
    if (id === 'more') this.querySelector('[data-imn-panel="more-main"]').hidden = false;
    this.currentPanel = id;
    this.scroller.scrollTop = 0;
    const heading = panel.querySelector('h2');
    if (heading) heading.focus({preventScroll:true});
  }
  goBack() {
    this.cancelMenuSwipe();
    const previous = this.history.pop();
    if (!previous) return;
    this.currentPanel = previous.panel;
    if (!previous.panel) this.reset();
    else {
      this.querySelectorAll('[data-imn-panel]').forEach(p => { p.hidden = true; });
      this.querySelector('[data-imn-panel="' + previous.panel + '"]').hidden = false;
      if (previous.panel === 'more') this.querySelector('[data-imn-panel="more-main"]').hidden = false;
    }
    this.scroller.scrollTop = previous.scroll;
    previous.trigger.focus({preventScroll:true});
  }
  disconnectedCallback() {
    clearTimeout(this.openMenuTimer);
    this.openMenuTimer = null;
    if (this.opener) this.opener.classList.remove('imn-menu-pressed');
    this.cancelMenuSwipe();
    this.dialog.removeEventListener('pointerdown', this.swipePointerDown);
    this.dialog.removeEventListener('pointermove', this.swipePointerMove);
    ['pointerup','pointercancel','lostpointercapture'].forEach(type => this.dialog.removeEventListener(type, this.swipePointerEnd));
    this.dialog.removeEventListener('click', this.swipeClickHandler, true);
    this.tabs.removeEventListener('pointerdown',this.tabPointerDown);
    this.tabs.removeEventListener('pointermove',this.tabPointerMove);
    ['pointerup','pointercancel','lostpointercapture'].forEach(type => this.tabs.removeEventListener(type,this.tabPointerEnd));
    document.removeEventListener('click', this.openHandler, true);
    window.removeEventListener('resize', this.resizeHandler);
    document.documentElement.classList.remove('imn-open');
  }
}
if (!customElements.get('ideal-mobile-navigation')) customElements.define('ideal-mobile-navigation', IdealMobileNavigation);
